export default "__VITE_ASSET__8ce72aa0__"